import { reportSessionEvent } from "./sessionTrace";

export const CustomErrorLogger = async (error, context = "General") => {
    try {
        let errorMessage = "Unknown error";
        let errorStack = "No stack trace";
        let statusCode = null;

        if (typeof error === "string") {
            errorMessage = error;
        } else if (error instanceof Error) {
            errorMessage = error.message;
            errorStack = error.stack || "No stack trace";
            statusCode = error.response?.status ?? null;
        } else if (error?.response) {
            statusCode = error.response.status;
            errorMessage = `API Error: ${error.response.status} ${error.response.statusText}`;
            errorStack = JSON.stringify(error.response.data, null, 2);
        } else if (typeof error === "object") {
            errorMessage = JSON.stringify(error, null, 2);
        }

        if (statusCode === 401) {
            console.warn("Skipping log for 401 Unauthorized error.");
            return;
        }

        await reportSessionEvent('ui.error', {
            level: 'error',
            context,
            message: errorMessage,
            stack: errorStack,
            status: statusCode,
            path: typeof window !== 'undefined' ? window.location.pathname : '',
        });
    } catch (logError) {
        console.error("Error logging failed:", logError);
    }
};
